import script from "./RegisteringI18nCheckPatientId.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisteringI18nCheckPatientId.vue?vue&type=script&setup=true&lang=ts"

import "./RegisteringI18nCheckPatientId.vue?vue&type=style&index=0&id=5a7ed894&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7ed894"]])

export default __exports__